import React from 'react';
import {Radio} from "antd";
import {capitalizeString} from '../../utils/stringUtils';

export function YesNoBoolean({value, onChange}) {
  return <YesNo value={value === 'Yes'} onChange={v => onChange(v === 'Yes')} />;
}

export function YesNo({value, defaultValue, onChange, ...props}) {
  const val = value ? capitalizeString(value) : capitalizeString(defaultValue);
  return (<Radio.Group style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}} buttonStyle="solid" value={val} onChange={e => onChange(e.target.value)} {...props} >
    <Radio.Button style={{height: '31px', width: '108px', textAlign: 'center'}} className='yes-no' value={"Yes"}>Yes</Radio.Button>
    <Radio.Button style={{height: '31px', width: '108px', textAlign: 'center'}} className='yes-no' value={"No"}>No</Radio.Button>
  </Radio.Group>);
}
